/* eslint-disable */
import React, { useState, useEffect } from 'react';

const ReportViewPopup = (props) => {
    const adminEditor = props.reportViewForm.userType === 'admin'
    const [naicsSearchQuery, setNaicsSearchQuery] = useState('');
    const [parentSearchQuery, setParentSearchQuery] = useState('');
    const [companySearchQuery, setCompanySearchQuery] = useState('');
    const [debouncedQuery, setDebouncedQuery] = useState({ naics: '', parent: '', company: '' });
    const [reportViewFormState, setReportViewFormState] = useState({
        name: '',
        displayApplyQ: true,
        viewApply: props.reportViewForm.view_apply ? props.reportViewForm.view_apply : 'all_firm_clients',
        naicsSpecific: props.reportViewForm.naicsSpecific || 'no',
        parentSpecific: props.reportViewForm.parentSpecific || 'no',
    })
    const [naicsSearch, setNaicsSearch] = useState({
        isLoading: false,
        selected: props.reportViewForm.naicsSearch,
        results: []
    })
    const [parentSearch, setParentSearch] = useState({
        isLoading: false,
        selected: props.reportViewForm.parentSearch,
        results: []
    })
    const [companySearch, setCompanySearch] = useState({
        isLoading: false,
        selected: props.reportViewForm.companySearch,
        results: []
    })


    const handleReportViewForm = (type, value) => {
        setReportViewFormState((prevState) => {
            switch (type) {
                case 'name':
                    return {
                        ...prevState,
                        name: value,
                    }
                case 'viewApply':
                    return {
                        ...prevState,
                        viewApply: value,
                    }
                case 'naicsSpecific':
                    return {
                        ...prevState,
                        naicsSpecific: value
                    }
                case 'parentSpecific':
                    return {
                        ...prevState,
                        parentSpecific: value
                    }
            }
        })

    }

    const handleFormInputs = (e, type) => {
        let value = e.target.value;

        switch (type) {
            case 'name':
                props.setReportViewForm(prevState => {
                    return {
                        ...prevState,
                        name: value
                    }
                })
                break;

            default:
                break;
        }
    }

    const handleSelectedNAICS = (action, naicsCode) => {
        if (action === 'add') {
            setNaicsSearch(prevState => {
                let newResults = prevState.results.filter(naics => naics !== naicsCode)
                let newSelected = [...prevState.selected, naicsCode]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        } else if (action === 'remove') {
            setNaicsSearch(prevState => {
                let newSelected = prevState.selected.filter(naics => naics !== naicsCode)
                let newResults = [naicsCode, ...prevState.results]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        }
    }

    const handleSelectedParent = (action, parent) => {
        if (action === 'add') {
            setParentSearch(prevState => {
                let newResults = prevState.results.filter(p => p.id !== parent.id)
                let newSelected = [...prevState.selected, parent]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        } else if (action === 'remove') {
            setParentSearch(prevState => {
                let newSelected = prevState.selected.filter(p => p.id !== parent.id)
                let newResults = [parent, ...prevState.results]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        }
    }

    const handleSelectedCompany = (action, company) => {
        if (action === 'add') {
            setCompanySearch(prevState => {
                let newResults = prevState.results.filter(p => p.id !== company.id)
                let newSelected = [...prevState.selected, company]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        } else if (action === 'remove') {
            setCompanySearch(prevState => {
                let newSelected = prevState.selected.filter(p => p.id !== company.id)
                let newResults = [company, ...prevState.results]
                return {
                    ...prevState,
                    results: newResults,
                    selected: newSelected
                }
            })
        }
    }

    const handleNAICSInputChange = (e) => {
        setNaicsSearchQuery(e.target.value);
    };

    const handleParentInputChange = (e) => {
        setParentSearchQuery(e.target.value);
    };

    const handleCompanyInputChange = (e) => {
        setCompanySearchQuery(e.target.value);
    }

    const handleReportViewSubmit = (e) => {
        e.preventDefault()
        let formData = reportViewFormState
        formData["naics"] = reportViewFormState.naicsSpecific === 'yes' ? naicsSearch.selected : null
        formData["parent_ids"] = reportViewFormState.parentSpecific === 'yes' ? parentSearch.selected.map(p => p.id) : null
        formData["company_ids"] = reportViewFormState.viewApply === 'specific_clients' ? companySearch.selected.map(p => p.id) : null

        if (props.reportViewForm.action === 'create') {
            props.createReportView(formData)
        } else {
            props.updateReportView(formData)
        }
    }

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedQuery({
                naics: naicsSearchQuery,
                parent: parentSearchQuery,
                company: companySearchQuery
            });
        }, 1000);

        return () => clearTimeout(handler);
    }, [naicsSearchQuery, parentSearchQuery, companySearchQuery]);

    useEffect(() => {
        const fetchSearchData = async (queryType, queryValue) => {
            if (!queryValue) return;

            if (queryType === 'naics') {
                setNaicsSearch(prev => ({ ...prev, isLoading: true }));
            } else if (queryType === 'company' && adminEditor) {
                setParentSearch(prev => ({ ...prev, isLoading: true }));
            } else {
                setCompanySearch(prev => ({ ...prev, isLoading: true }));
            }

            try {
                const response = await fetch(`/api/v1/${queryType}_search/?term=${queryValue}`);
                if (!response.ok) throw new Error('Network error');

                const data = await response.json();

                if (queryType === 'naics') {
                    let filteredNaics = []
                    data.results.forEach(n => {
                        if (!naicsSearch.selected.includes(n)) {
                            filteredNaics.push(n)
                        }
                    })
                    setNaicsSearch(prev => ({ ...prev, isLoading: false, results: filteredNaics }));
                } else if (queryType === 'company' && adminEditor) {
                    let filteredParent = []
                    data.admin_results.forEach(p => {
                        if (!parentSearch.selected.find(r => r.id === p.id)) {
                            filteredParent.push(p)
                        }
                    })
                    setParentSearch(prev => ({ ...prev, isLoading: false, results: filteredParent }));
                } else {
                    let filteredCompanies = []
                    data.firm_results.forEach(p => {
                        if (!companySearch.selected.find(r => r.id === p.id)) {
                            filteredCompanies.push(p)
                        }
                    })
                    setCompanySearch(prev => ({ ...prev, isLoading: false, results: filteredCompanies }));
                }
            } catch (error) {
                console.error(`Error fetching ${queryType} data:`, error);
            }
        };

        fetchSearchData('naics', debouncedQuery.naics);
        fetchSearchData('company', debouncedQuery.parent);
        fetchSearchData('company', debouncedQuery.company);
    }, [debouncedQuery]);

    const renderForm = () => {
        return (
            <div>
                <h2>{props.reportViewForm.action === 'create' ? 'Save a New Report View' : 'Edit Current Report View'}</h2>
                <p>Please make sure you are happy with your current tabs displayed and filters for each tab before saving.</p>
                {
                    props.userType === 'Admin' && (
                        <div className='admin-report-view-btn'>
                            {props.reportViewForm.userType !== 'admin' ? <button onClick={() => props.handleReportViewEditModal('admin')}>Super Admin? Click Here to set report view as a default for app.</button> : <button onClick={() => props.handleReportViewEditModal('normal')}>Switch Back to Normal</button>}
                        </div>
                    )
                }
                {/* Hide admin button on edit report view */}
                {adminEditor && <p>You are in Super Admin view. This view will be created as default views for the app.</p>}
                <form id='report-view-form' onSubmit={(e) => handleReportViewSubmit(e)}>
                    <div>
                        <label htmlFor='report-view-name'>{props.reportViewForm.action === 'create' ? 'New Report View Name:' : 'Edit Report View Name:'}</label>
                        <input id='report-view-name' type='text' maxLength='30' value={props.reportViewForm.name} onChange={(e) => handleFormInputs(e, 'name')} required />
                    </div>

                    {!adminEditor && <>
                        <div className='report-view-radio-q-div'>
                            <span>Is this Report View accessible to all clients?</span>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='all-firm-clients'
                                    name='dashboard-view-apply'
                                    value='all_firm_clients'
                                    checked={reportViewFormState.viewApply === 'all_firm_clients'}
                                    onChange={(e) => handleReportViewForm('viewApply', e.target.value)}
                                />
                                <label htmlFor='all-firm-clients'>All Firm Clients</label>
                            </div>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='all-my-clients-naics'
                                    name='dashboard-view-apply'
                                    value='all_firm_clients_naics'
                                    checked={reportViewFormState.viewApply === 'all_firm_clients_naics'}
                                    onChange={(e) => handleReportViewForm('viewApply', e.target.value)}
                                />
                                <label htmlFor='all-my-clients-naics'>All Clients with the same NAICS code</label>
                            </div>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='specific-clients'
                                    name='dashboard-view-apply'
                                    value='specific_clients'
                                    checked={reportViewFormState.viewApply === 'specific_clients'}
                                    onChange={(e) => handleReportViewForm('viewApply', e.target.value)}
                                />
                                <label htmlFor='specific-clients'>Specific Clients</label>
                            </div>
                            <div>
                                {
                                    reportViewFormState.viewApply === 'specific_clients'
                                        ? (<div className='search-clients-section'>
                                            <input className='client-search-bar' placeholder='Search for Client' type="text" onChange={(e) => handleCompanyInputChange(e)} />
                                            <div className='clients-search-wrap'>
                                                <span>Selected</span>
                                                {companySearch.selected.map(s => {
                                                    return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedCompany('remove', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>&#10003;</span></div>
                                                })}
                                            </div>
                                            <div className='clients-search-wrap'>
                                                <span>Results</span>
                                                {companySearch.results.map(s => {
                                                    return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedCompany('add', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>+</span></div>
                                                })}
                                            </div>
                                        </div>)
                                        : null
                                }
                            </div>
                        </div>
                    </>
                    }

                    {adminEditor && <>
                        <div className='one-line-q'>
                            <span>Is this NAICS specific?</span>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='naics-yes'
                                    name='dashboard-view-visibility'
                                    value='yes'
                                    checked={reportViewFormState.naicsSpecific === 'yes'}
                                    onChange={(e) => handleReportViewForm('naicsSpecific', e.target.value)}
                                    required
                                />
                                <label htmlFor='naics-yes'>Yes</label>
                            </div>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='naics-no'
                                    name='dashboard-view-visibility'
                                    value='no'
                                    checked={reportViewFormState.naicsSpecific === 'no'}
                                    onChange={(e) => handleReportViewForm('naicsSpecific', e.target.value)}
                                />
                                <label htmlFor='naics-no'>No</label>
                            </div>
                        </div>
                        <div>
                            {
                                reportViewFormState.naicsSpecific === 'yes'
                                    ? (<div className='search-clients-section'>
                                        <input className='client-search-bar' placeholder='Search for NAICS' type="text" onChange={(e) => handleNAICSInputChange(e)} />
                                        <div className='clients-search-wrap'>
                                            <span>Selected</span>
                                            {naicsSearch.selected.map(s => {
                                                return <div key={s} className='company-name-btn' onClick={() => handleSelectedNAICS('remove', s)}><span>{s}</span><span style={{ 'color': '#000000' }}>&#10003;</span></div>
                                            })}
                                        </div>
                                        <div className='clients-search-wrap'>
                                            <span>Results</span>
                                            {naicsSearch.results.map(s => {
                                                return <div key={s} className='company-name-btn' onClick={() => handleSelectedNAICS('add', s)}><span>{s}</span><span style={{ 'color': '#000000' }}>+</span></div>
                                            })}
                                        </div>
                                    </div>)
                                    : null
                            }
                        </div>
                    </>}

                    {adminEditor && <>
                        <div className='one-line-q'>
                            <span>Is this Firm / Parent Company specific?</span>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='parent-yes'
                                    name='dashboard-view-permissions'
                                    value='yes'
                                    checked={reportViewFormState.parentSpecific === 'yes'}
                                    onChange={(e) => handleReportViewForm('parentSpecific', e.target.value)}
                                    required
                                />
                                <label htmlFor='parent-yes'>Yes</label>
                            </div>
                            <div className='report-view-radio-q'>
                                <input
                                    type='radio'
                                    id='parent-no'
                                    name='dashboard-view-permissions'
                                    value='no'
                                    checked={reportViewFormState.parentSpecific === 'no'}
                                    onChange={(e) => handleReportViewForm('parentSpecific', e.target.value)}
                                />
                                <label htmlFor='parent-no'>No</label>
                            </div>
                        </div>
                        <div>
                            {
                                reportViewFormState.parentSpecific === 'yes'
                                    ? (<div className='search-clients-section'>
                                        <input className='client-search-bar' placeholder='Search for Parent Company / Firm' type="text" onChange={(e) => handleParentInputChange(e)} />
                                        <div className='clients-search-wrap'>
                                            <span>Selected</span>
                                            {parentSearch.selected.map(s => {
                                                return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedParent('remove', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>&#10003;</span></div>
                                            })}
                                        </div>
                                        <div className='clients-search-wrap'>
                                            <span>Results</span>
                                            {parentSearch.results.map(s => {
                                                return <div key={s.name} className='company-name-btn' onClick={() => handleSelectedParent('add', s)}><span>{s.name}</span><span style={{ 'color': '#000000' }}>+</span></div>
                                            })}
                                        </div>
                                    </div>)
                                    : null
                            }
                        </div>
                    </>
                    }
                    <div className='report-view-popup-buttons'>
                        <button type='submit'>{props.reportViewForm.action === 'create' ? 'Create New Report View' : 'Save Changes to Report View'}</button>
                        {props.reportViewForm.action === 'create' ? null : <button className='red-btn' type='button' onClick={() => props.archiveReportView()}>Archive View</button>}
                        <button className='red-btn' type='button' onClick={() => props.setReportViewEditIsOpen(false)}>CLOSE</button>
                    </div>
                </form>
            </div>
        )
    }

    return renderForm();
}

export default ReportViewPopup;